export enum AlertType {
  Info = 'info',
  Error = 'error',
  Warn = 'warn',
  Primary = 'primary',
}
